import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation, Pagination]);

export default () => {
  return {
    props: {
      slidesPerView: {
        type: Number,
        default: 2,
      },
      rotatingInterval: {
        type: Number,
        default: 0,
      },
    },
    mounted() {
      this.initCarousel();
    },
    methods: {
      initCarousel() {
        this.swiper = new Swiper(this.$el.querySelector(".swiper"), {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            767: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: this.slidesPerView,
            },
          },
          autoplay: {
            delay: this.rotatingInterval,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      },
    },
  };
};
